
import Vue from 'vue';

const filter = function (value: string, length: number, clamp: string) {
    if (!value) return '';
    clamp = clamp || '...';
    return value.length > length ? value.slice(0, length) + clamp : value;
};

Vue.filter('truncate', filter);